import { LocaleResources } from 'locales';
import { createContext } from 'react';

export const I18nContext = createContext<LocaleResources>({} as LocaleResources);
